import React, { useMemo } from "react";
import CommonTable from "../../common/CommonTable";
import {
  formatClaimLanguage,
  getClaimTypeLabel,
  getQuizMeta,
  getQuizPagination,
  getQuizSetsTableData,
} from "./claimViewUtils";

const quizSetColumns = (onViewSet) => [
  {
    title: "Set Number",
    dataIndex: "setNumberLabel",
    key: "setNumberLabel",
    sorter: {
      compare: (a, b) => a.setNumber - b.setNumber,
    },
  },
  {
    title: "Set Title",
    dataIndex: "setTitle",
    key: "setTitle",
    sorter: {
      compare: (a, b) => a.setTitle.localeCompare(b.setTitle),
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Action",
    key: "action",
    render: (row) => (
      <div className="action-icons">
        <button className="manage" type="button" onClick={() => onViewSet(row)}>
          View
        </button>
      </div>
    ),
  },
];

const ClaimQuizViewOnly = ({
  claimDetail = {},
  onViewSet,
  quizPagination = {},
  isLoading = false,
  onQuizSetPageChange,
}) => {
  const languageLabel = formatClaimLanguage(claimDetail?.language);
  const { quizName, quizDescription } = getQuizMeta(claimDetail);
  const paginationMeta = {
    ...getQuizPagination(claimDetail),
    ...quizPagination,
  };
  const quizSetsTableData = useMemo(
    () => getQuizSetsTableData(claimDetail),
    [claimDetail],
  );

  const pagination = {
    current: paginationMeta.currentPage,
    pageSize: paginationMeta.pageSize,
    total: paginationMeta.totalSets,
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 15, 20],
    className: "order-pagination",
    locale: { items_per_page: "" },
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  };

  return (
    <>
      <div className="product-view-info mb-30">
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Name</p>
          <p className="product-view-info-value">{claimDetail?.claimName || "-"}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Type</p>
          <p className="product-view-info-value">
            {getClaimTypeLabel(claimDetail?.claimType)}
          </p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Language</p>
          <p className="product-view-info-value">{languageLabel}</p>
        </div>
        <div className="product-view-info-divider" aria-hidden="true" />
        <div className="product-view-info-field">
          <p className="product-view-info-label">Claim Status</p>
          <p className="product-view-info-value">
            {claimDetail?.claimStatus || "-"}
          </p>
        </div>
      </div>

      <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
        <p className="claim-form-view-only-title mb-0">
          Quiz - For {languageLabel}
        </p>
        <hr className="my-3" />
        <div className="claim-form-view-only-field mb-4">
          <p className="claim-form-view-only-label">Title</p>
          <p className="claim-form-view-only-value mb-0">{quizName || "-"}</p>
        </div>
        <div className="claim-form-view-only-field">
          <p className="claim-form-view-only-label">Description</p>
          <p className="claim-form-view-only-value mb-0">
            {quizDescription || "-"}
          </p>
        </div>
      </div>

      <div className="table-padding mb-30">
        <div className="headtitle">
          <p className="mb-0 heedprodct">Sets</p>
        </div>
        <hr className="m-0" />
        <div className="table-responsive">
          {/* As Discussed with nasir and unnati quizData loop added instead of quizData Object, we need to show the sets in the table */}
          <CommonTable
            body={quizSetsTableData}
            columns={quizSetColumns(onViewSet)}
            handlePageChange={onQuizSetPageChange}
            pagination={pagination}
            tableLoading={isLoading}
          />
        </div>
      </div>
    </>
  );
};

export default ClaimQuizViewOnly;
